// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr, Tooltip } from "@revvsales/components";

// Component Imports
import ManageTeammatesPopup from "../../../SettingsWrapper/TeammatesSettings/ManageTeammatesPopup";
import ShowUserLimitIncreaseRequestPopup from "../../../ShowUserLimitIncreaseRequestPopup/index";

// Actions Imports
import { getMeterUsageService } from "../../../../actions/CommonActions/commonService";

// Internal Imports
import { GlobalUtils } from "../../../../utils";
import { BILLING } from "../../../../constants";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;
const { BILLINGS_ENTITY_CONSUMPTION_POINT } = BILLING;

class InviteTeamMemberBtn extends Component {
  state = {
    showInviteTeamMateModal: false,
    teamMateUsage: { limit: 0, usage: 0 },
  };

  componentDidMount() {
    this._checkUserConsumption();
  }

  _checkUserConsumption = () => {
    getMeterUsageService(BILLINGS_ENTITY_CONSUMPTION_POINT.USER_LICENCES)
      .then(res => {
        this.setState({ teamMateUsage: res });
      })
      .catch(error => {
        console.error(
          `getMeterUsageService => getMeterUsageService => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Failed to fetch user consumption record.",
          timeout: 3000,
        });
      });
  };

  _toggleInviteTeamMateModal = () => {
    this.setState(prevState => ({
      showInviteTeamMateModal: !prevState.showInviteTeamMateModal,
    }));
  };

  _decideModalView = () => {
    const {
      teamMateUsage: { limit, usage },
    } = this.state;
    const isUsageLimitExceeded = limit <= usage;

    if (isUsageLimitExceeded) {
      return (
        <ShowUserLimitIncreaseRequestPopup
          userConsumptionRecord={this.state.teamMateUsage}
          onClose={this._toggleInviteTeamMateModal}
        />
      );
    }
    return (
      <ManageTeammatesPopup
        closePopup={this._toggleInviteTeamMateModal}
        roles={this.props.orgRolesList}
        teammate={{}}
        isInviteFromCTA
      />
    );
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const isAdminUser = CURRENT_USER.roles[0].name === "Admin";

    if (isAdminUser) {
      return (
        <Fragment>
          <div>
            <Tooltip
              align={{
                offset: [0, -4],
              }}
              placement="bottom"
              overlay="Invite teammate to Revv">
              <span
                data-test="cta-user-invite-btn"
                className="inviteteammemberbtn-wrapper"
                onClick={this._toggleInviteTeamMateModal}
                onKeyPress={() => {}}
                tabIndex="0"
                role="button">
                <FontAwesomeIcon icon={["fas", "user-plus"]} />
              </span>
            </Tooltip>
          </div>
          <div className="inviteteammemberbtn-seperator" />

          {this.state.showInviteTeamMateModal && this._decideModalView()}
        </Fragment>
      );
    }
    return null;
  }
}

InviteTeamMemberBtn.defaultProps = {};

InviteTeamMemberBtn.propTypes = {};

const mapStateToProps = state => {
  const { orgRolesList } = state.SettingsStore;

  return {
    orgRolesList,
  };
};

export default connect(mapStateToProps)(InviteTeamMemberBtn);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Buttons/inviteTeamMemberBtn/index.js